import NavbarLink from "./NavbarLink";

export default function NavigationLinkContainer({ NAVIGATION_LINKS, mobileNavbar, closeNavbar }) {
 if (!mobileNavbar) {
  // Desktop
  return (
   <div className="nav-container">
    {
     NAVIGATION_LINKS.map((link, index) => (
      <NavbarLink title={link.title} path={link.path} external={link.external} newTab={link.newTab} key={index} subLinks={link.subLinks}></NavbarLink>
     ))
    }
   </div>
  )
 } else {
  // Mobile
  return NAVIGATION_LINKS.map((link, index) => (
   <NavbarLink title={link.title} path={link.path} key={index} closeNavbar={closeNavbar} newTab={link.newTab} external={link.external} subLinks={link.subLinks}></NavbarLink>
  ));
 }
}